const STATS = [
  { value: "500+", label: "Clientes atendidos" },
  { value: "95%", label: "Taxa de êxito" },
  { value: "+10", label: "Anos de experiência" },
];

export default function About() {
  return (
    <section
      id="sobre"
      className="w-full relative py-24 px-6 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/af06a004-2aed-4cb1-9057-9684b271c567_PATTERN-JPG.jpg?v=ee5ffbdeb4acbf089ee1ea55a2a3cd7a"
          alt="Background pattern"
          className="w-full h-full object-cover object-center"
        />
        <div
          className="absolute inset-0"
          style={{ backgroundColor: "rgba(40, 18, 14, 0.88)" }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16">

          {/* Left — Photo */}
          <div className="relative flex-shrink-0 w-full lg:w-[420px]">
            {/* Photo */}
            <div className="rounded-2xl overflow-hidden w-full" style={{ height: "520px" }}>
              <img
                src="https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/caf39009-7df7-4783-8296-7f43c1f0ee83_ADV---SUELLEN-08832.jpg?v=4e5bc48f6162dde83b772540184db2c4"
                alt="Dra. Suellen Martins"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Stats card overlapping */}
            <div
              className="absolute -bottom-6 -right-4 lg:-right-10 rounded-2xl px-6 py-5 shadow-lg"
              style={{ backgroundColor: "#ffffff", minWidth: "220px" }}
            >
              <div className="grid grid-cols-3 gap-4">
                {STATS.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <p
                      className="font-display text-2xl font-bold leading-tight"
                      style={{ color: "rgb(61, 35, 32)" }}
                    >
                      {stat.value}
                    </p>
                    <p
                      className="font-body text-[10px] mt-1 leading-snug"
                      style={{ color: "rgba(61, 35, 32, 0.55)" }}
                    >
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right — Text */}
          <div className="flex-1 flex flex-col gap-6 pb-6 lg:pb-0">
            {/* Eyebrow */}
            <p className="font-body text-peach text-xs tracking-[0.35em] uppercase font-medium">
              Sobre
            </p>

            {/* Title */}
            <h2 className="font-display text-4xl lg:text-5xl font-semibold leading-tight text-white">
              Dra. Suellen{" "}
              <span className="font-light italic text-peach">Martins</span>
            </h2>

            <div className="w-10 h-0.5 bg-peach" />

            {/* Paragraphs */}
            <p
              className="font-body text-base leading-relaxed"
              style={{ color: "rgba(255, 255, 255, 0.65)" }}
            >
              Com dedicação e sensibilidade, a Dra. Suellen Martins construiu sua trajetória no Direito Previdenciário com o firme propósito de{" "}
              <strong className="text-white font-medium">defender quem mais precisa</strong>{" "}
              — trabalhadores, aposentados e famílias que buscam seus direitos junto ao INSS.
            </p>

            <p
              className="font-body text-base leading-relaxed"
              style={{ color: "rgba(255, 255, 255, 0.65)" }}
            >
              Aqui, cada caso é tratado com atenção individualizada. Você não será apenas mais um processo — será uma pessoa com uma história, uma necessidade real, e merece{" "}
              <strong className="text-white font-medium">orientação clara, honesta e humana</strong>.
            </p>

            {/* OAB Badge */}
            <div className="flex items-center gap-3 mt-2">
              <div className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
                <i className="ri-shield-check-line text-peach text-base" />
              </div>
              <p
                className="font-body text-xs"
                style={{ color: "rgba(255, 255, 255, 0.45)" }}
              >
                OAB/PE Registrada · Especialista em Direito Previdenciário
              </p>
            </div>

            {/* CTA Button */}
            <div className="mt-2 flex justify-center lg:justify-start">
              <a
                href="https://wa.me/5581995913182?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2.5 font-body text-sm font-semibold px-7 py-3.5 whitespace-nowrap cursor-pointer transition-all duration-300 ease-in-out hover:opacity-90 active:scale-95"
                style={{
                  backgroundColor: "#ffffff",
                  color: "rgb(61, 35, 32)",
                  borderRadius: "40px",
                }}
              >
                <i className="ri-whatsapp-line text-base" />
                Agendar consulta
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
